import React, { useState, useEffect } from "react";
import "./Footer.css";
import logo from "../images/Mariamly Luxe - Logo.svg";
import { fetchContactInfo, formatPhoneForWhatsApp } from "../utils/contactInfo";

export default function Footer() {
  const [contactInfo, setContactInfo] = useState({
    phone: "+961-70 457 945",
    email: "info@mariamlyluxe.com",
    location: "Tripoli",
    instagram: null
  });

  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState({
    loading: false,
    success: false,
    error: null
  });

  useEffect(() => {
    const loadContactInfo = async () => {
      try {
        const info = await fetchContactInfo();
        setContactInfo(info);
      } catch (error) {
        console.error("Failed to load contact info:", error);
      }
    };

    loadContactInfo();
  }, []);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    if (!newsletterEmail.trim()) {
      setNewsletterStatus({
        loading: false,
        success: false,
        error: "Please enter a valid email address"
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newsletterEmail)) {
      setNewsletterStatus({
        loading: false,
        success: false,
        error: "Please enter a valid email address"
      });
      return;
    }

    setNewsletterStatus({
      loading: true,
      success: false,
      error: null
    });

    try {
      const response = await fetch("https://api.mariamlyluxe.com/public/api/newsletter/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: newsletterEmail
        })
      });

      if (response.ok) {
        setNewsletterStatus({
          loading: false,
          success: true,
          error: null
        });
        setNewsletterEmail("");
      } else {
        const errorData = await response.json();
        setNewsletterStatus({
          loading: false,
          success: false,
          error: errorData.message || "Failed to subscribe. Please try again."
        });
      }
    } catch (error) {
      console.error("Newsletter subscription error:", error);
      setNewsletterStatus({
        loading: false,
        success: false,
        error: "Network error. Please check your connection and try again."
      });
    }
  };
  return (
    <footer className="f-wrap">
      <div className="f-inner">
        {/* Brand / about */}
        <div className="f-brand">
          <div className="f-logo">
            <img src={logo} alt="Mariamly Luxe" />
          </div>
          <p>Proudly crafting custom cosmetics</p>
          <p>Since 2011 | Beauty tailored to you. Place your orders !</p>
        </div>

        {/* Company */}
        <div className="f-col">
          <h4>Company</h4>
          <ul>
            <li>
              <a href="/about">About us</a>
            </li>
            <li>
              <a href="/services">Services</a>
            </li>
            <li>
              <a href="/community">Community</a>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="f-col">
          <h4>Legal</h4>
          <ul>
            <li>
              <a href="/sales-policy">Sales Policy</a>
            </li>
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/exchange-policy">Exchange Policy</a>
            </li>
            <li>
              <a href="/ask-mariamly-policy">Ask Mariamly AI Policy</a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="f-col">
          <h4>Contact</h4>
          <ul className="f-contact">
            <li>
              <span className="ico" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
              </span>
              <a
                href={`https://wa.me/${formatPhoneForWhatsApp(contactInfo.phone)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {contactInfo.phone}
              </a>
            </li>
            <li>
              <span className="ico" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </span>
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
            </li>
            <li>
              <span className="ico" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </span>
              <span>{contactInfo.location}</span>
            </li>
            {contactInfo.instagram && (
              <li>
                <span className="ico" aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </span>
                <a
                  href={`https://www.instagram.com/${contactInfo.instagram.replace('@', '')}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contactInfo.instagram}
                </a>
              </li>
            )}
          </ul>
        </div>

        {/* Newsletter */}
        <div className="f-col f-news">
          <h4>Newsletter</h4>
          <p>Proudly crafting custom cosmetics</p>
          <p>Since 2025 | Beauty tailored to you. Place your orders !</p>
          <form className="news-form" onSubmit={handleNewsletterSubmit}>
            <input 
              type="email"
              placeholder="Enter your email" 
              value={newsletterEmail}
              onChange={(e) => setNewsletterEmail(e.target.value)}
              disabled={newsletterStatus.loading}
            />
            <button type="submit" disabled={newsletterStatus.loading}>
              {newsletterStatus.loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          
          {/* Newsletter Status Messages */}
          {newsletterStatus.success && (
            <div className="newsletter-success" style={{ color: "green", fontSize: "14px", marginTop: "8px" }}>
              ✓ Successfully subscribed to newsletter!
            </div>
          )}
          
          {newsletterStatus.error && (
            <div className="newsletter-error" style={{ color: "red", fontSize: "14px", marginTop: "8px" }}>
              ✗ {newsletterStatus.error}
            </div>
          )}
        </div>
      </div>

      <div className="f-divider" />

      <div className="f-bottom">
        <p>
          Powered By{" "}
          <a
            href="https://karhanii.com"
            target="_blank"
            rel="noopener noreferrer"
            className="f-powered"
          >
            Bachar Karhani
          </a>{" "}
          © {new Date().getFullYear()} Mariamly. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
